import { BlogFulfillmentList } from 'components/Pages/BlogArticle/BlogFulfillmentList/BlogFulfillmentList';
import { useBlogTransportsQueryApi } from 'graphql/generated';

export const BlogTransportsList: FC = () => {
    const [{ data }] = useBlogTransportsQueryApi();

    return (
        <BlogFulfillmentList
            freeFulfillmentLimit={data?.freeFulfillmentLimit}
            fulfillmentItems={data?.transportsList}
        />
    );
};
